export const getInterventionIcon = (interventionType) => {
  switch (interventionType) {
    case 'FLAG':
      return 'fa-flag';
    case 'KUDO':
      return 'fa-star';
    case 'REFERRAL':
      return 'fa-sign-in';
    case 'TO_DO':
      return 'fa-check-square-o';
    default:
      return 'sf-blank';
  }
}
